var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducationLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ede609f0-d638-4417-85b0-bab486f0436d",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340.25 355.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-6142636c-8dfb-4517-ae1e-edb06591faca {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-f6a2b020-b26b-4551-acf1-1418bb179a02",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-1cc5c548-4e73-4fe9-ae46-c2235954e781",
    "data-name": "Education"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    d: "M141.74,355.31c-2.96,0-5.92-.76-8.56-2.29l-108.68-62.98c-15.11-8.72-24.51-25-24.51-42.47V107.76c0-17.47,9.4-33.74,24.52-42.48L133.17,2.56c5.27-3.04,11.81-3.04,17.07,0,5.26,3.04,8.53,8.7,8.53,14.78l.03,320.91h0c0,6.08-3.27,11.75-8.55,14.79-2.63,1.51-5.58,2.27-8.52,2.27ZM134.78,29.34l-98.25,56.73c-7.72,4.46-12.52,12.77-12.52,21.69v139.81c0,8.92,4.8,17.23,12.52,21.69l98.28,56.96-.03-296.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    d: "M197.88,355.33c-2.95,0-5.91-.76-8.54-2.28-5.26-3.04-8.53-8.71-8.52-14.78h0s.18-321.21.18-321.21c0-6.08,3.27-11.74,8.54-14.77,5.26-3.04,11.8-3.04,17.06,0l109.13,63.01c15.13,8.73,24.52,25.01,24.52,42.47v139.81c0,17.47-9.4,33.74-24.52,42.47l-109.32,63.01c-2.63,1.52-5.58,2.27-8.52,2.27ZM204.99,29.07l-.17,297.2,98.91-57.01c7.72-4.46,12.52-12.77,12.52-21.69V107.76c0-8.92-4.8-17.23-12.52-21.69l-98.74-57.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    cx: 107.25,
    cy: 102.06,
    r: 21.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    d: "M107.25,113.06c-2.86,0-5.71-1.11-7.87-3.31l-22.52-23.03c-5.46-5.58-8.46-12.96-8.46-20.77v-18.1c0-6.08,4.92-11,11-11s11,4.92,11,11v18.1c0,2.03.78,3.94,2.2,5.39l22.52,23.04c4.25,4.34,4.17,11.31-.18,15.56-2.14,2.09-4.92,3.13-7.69,3.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    cx: 99.97,
    cy: 208.72,
    r: 21.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    x: 47.44,
    y: 170.06,
    width: 22,
    height: 77.05,
    transform: "translate(-150.34 266.34) rotate(-89.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    cx: 58.18,
    cy: 135.48,
    r: 21.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    d: "M134.39,174.33h-40.1c-7.81,0-15.19-3.01-20.77-8.47l-23.04-22.52c-4.34-4.25-4.42-11.21-.18-15.56,4.25-4.34,11.21-4.42,15.56-.18l23.04,22.52c1.45,1.42,3.36,2.2,5.39,2.2h40.1c6.08,0,11,4.92,11,11s-4.92,11-11,11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    cx: 240.7,
    cy: 195.12,
    r: 21.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    d: "M316.91,233.97h-40.1c-7.81,0-15.18-3.01-20.77-8.46l-23.04-22.52c-4.34-4.25-4.42-11.21-.18-15.56,4.25-4.34,11.21-4.42,15.56-.18l23.04,22.52c1.45,1.42,3.36,2.2,5.39,2.2h40.1c6.08,0,11,4.92,11,11s-4.92,11-11,11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    cx: 77.16,
    cy: 253.62,
    r: 21.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    d: "M105.01,330.84c-6.08,0-11-4.92-11-11v-30.1c0-2.03-.78-3.94-2.2-5.39l-22.52-23.04c-4.25-4.34-4.17-11.31.18-15.56,4.34-4.25,11.31-4.17,15.56.18l22.52,23.04c5.46,5.58,8.46,12.96,8.46,20.77v30.1c0,6.08-4.92,11-11,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    d: "M328.25,191.78h-25.18c-18.7,0-33.9-15.21-33.9-33.9v-38.41c0-6.08,4.92-11,11-11s11,4.92,11,11v38.41c0,6.56,5.34,11.9,11.9,11.9h25.18c6.08,0,11,4.92,11,11s-4.92,11-11,11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    cx: 278.63,
    cy: 106.86,
    r: 21.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    d: "M205.79,166.42h-12.88c-6.08,0-11-4.92-11-11s4.92-11,11-11h12.88c6.56,0,11.91-5.34,11.91-11.9v-38.41c0-6.08,4.92-11,11-11s11,4.92,11,11v38.41c0,18.7-15.21,33.9-33.91,33.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    cx: 230.23,
    cy: 81.5,
    r: 21.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    cx: 248.25,
    cy: 266.58,
    r: 21.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-6142636c-8dfb-4517-ae1e-edb06591faca",
    x: 187.2,
    y: 255.71,
    width: 61.05,
    height: 22,
    transform: "translate(-1.11 .91) rotate(-.24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationLight);
export default __webpack_public_path__ + "static/media/EducationLight.75b89eaa0682fa9f668ef5005847be5f.svg";
export { ForwardRef as ReactComponent };